import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const tabs = [
  { path: '/', label: 'Home' },
  { path: '/lender-profiles', label: 'Lender Profiles' },
  { path: '/settings', label: 'Settings' },
];

export default function Layout() {
  const { username, logout } = useAuth();

  return (
    <div className="layout">
      <header className="topbar">
        <div className="topbar-brand">TC Refi Package Generator</div>
        <nav className="topbar-nav">
          {tabs.map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.path === '/'}
              className={({ isActive }) => `nav-tab ${isActive ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <div className="topbar-user">
          <span>{username}</span>
          <button onClick={logout} className="btn-logout">Logout</button>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
